import { useEffect, useState } from "react";
import { X } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";

export default function TemplatesModal({ onClose, onCreated }) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    api.get("/automations/templates").then((r) => setTemplates(r.data)).catch(() => {});
  }, []);

  const use = async (id) => {
    setLoading(id);
    try {
      const r = await api.post("/automations/from-template", { template_id: id });
      toast.success("Workflow creato dal template (disattivato: attivalo quando è pronto)");
      onCreated(r.data);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-2xl rounded-t-xl sm:rounded-lg max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="templates-modal">
        <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-200">
          <div>
            <h3 className="font-display font-bold text-lg">Libreria template</h3>
            <p className="text-xs text-zinc-500">Workflow pronti per i ristoranti — personalizzali dopo la creazione</p>
          </div>
          <button onClick={onClose} className="p-2 text-zinc-500" data-testid="templates-close"><X size={18} /></button>
        </div>
        <div className="p-5 grid sm:grid-cols-2 gap-3 overflow-y-auto">
          {templates.map((t) => (
            <div key={t.id} className="border border-zinc-200 rounded-lg p-4 flex flex-col" data-testid={`template-${t.id}`}>
              <div className="font-display font-bold text-zinc-900 text-sm">{t.name}</div>
              <p className="text-xs text-zinc-500 mt-1 flex-1">{t.description}</p>
              <div className="flex items-center justify-between mt-3">
                <span className="text-[10px] uppercase tracking-wide font-semibold text-zinc-400">{t.blocks} blocchi</span>
                <button onClick={() => use(t.id)} disabled={loading === t.id} data-testid={`use-template-${t.id}`}
                  className="h-9 px-4 rounded-md bg-zinc-900 text-white text-xs font-bold hover:bg-zinc-800 active:scale-95 transition disabled:opacity-50">
                  {loading === t.id ? "Creazione..." : "Usa template"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
